module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.0efdcad2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Medium/Rubik-Medium.woff
// module id = 1302
// module chunks = 49